import { Box, Typography, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, IconButton, useMediaQuery, useTheme, Card, CardContent, CardActions, Button } from '@mui/material';
import { VCalendar } from '../../shared';
import { FormatedDate, helpers } from '../../../services/helpers/helpers';
import { Comment, Search } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import React from 'react';

type MaintenanceBodyProps = {
    values: FormatedDate[];
}

export const MaintenanceBody = ({ values }: MaintenanceBodyProps) => {

    const navigate = useNavigate();
    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));   

    const MobileMaintenanceCard = ({ item }: { item: FormatedDate }) => (
        <Card variant="outlined" sx={{ mb: 2, borderRadius: '15px', overflow: 'hidden' }}>
            <CardContent sx={{ pb: 1 }}>
                <Typography
                    variant="h6"
                    component="div"
                    sx={{
                        wordBreak: 'break-word',
                        fontSize: smDown ? '1rem' : '1.125rem',
                        lineHeight: 1.2,
                        mb: (item.descricao || item.date) ? 1 : 0
                    }}
                >
                    {item.nome}
                </Typography>
                {item.descricao && (
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                            mb: item.date ? 1 : 0,
                            wordBreak: 'break-word',
                            fontSize: smDown ? '0.8rem' : '0.875rem',
                            lineHeight: 1.3
                        }}
                    >
                        {item.descricao}
                    </Typography>
                )}

                {item.date && (
                    <Box mt={1}>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                            Data(s):
                        </Typography>
                        <Typography variant="body2" color="text.primary" sx={{ wordBreak: 'break-word' }}>
                            {item.date}
                        </Typography>
                    </Box>
                )}

            </CardContent>
            <CardActions sx={{ justifyContent: 'flex-end', p: 2, pt: 0 }}>
                <Button
                    startIcon={<Search />}
                    onClick={() => navigate(`./${item.uuid}`)}
                    size="small"
                    variant="outlined"
                    fullWidth
                >
                    Ver Detalhes
                </Button>
                <Button
                    startIcon={<Comment />}
                    onClick={() => navigate(`./${item.uuid}/chat`)}
                    size="small"
                    variant="outlined"
                    fullWidth
                >
                    Comentários
                </Button>
            </CardActions>
        </Card>
    );

    return (
        <Box padding={smDown ? 1 : 2}>
            <Typography variant='h6' align='center' mb={smDown ? 2 : 3}>
                Manutenções
            </Typography>
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    marginTop: 1,
                    flexDirection: { xs: 'column', sm: 'row' },
                    justifyContent: 'center',
                    alignItems: { xs: 'center', sm: 'flex-start' }
                }}
            >
                <Box
                    sx={{
                        width: { xs: '100%', sm: '50%' },
                        maxWidth: '400px',
                        mb: smDown ? 2 : 0,
                        pr: smDown ? 0 : 2,
                        display: 'flex',
                        justifyContent: 'center'
                    }}
                >
                    <VCalendar values={values} />
                </Box>

                <Box
                    sx={{
                        padding: { xs: 0, sm: 1 },
                        width: { xs: '100%', sm: '50%' }
                    }}
                >
                    {smDown ? (
                        values.length > 0 ? (
                            values.map((item, index) => (
                                <MobileMaintenanceCard key={index} item={item} />
                            ))
                        ) : (
                            <Paper sx={{ p: 3, textAlign: 'center', borderRadius: '15px' }}>
                                <Typography color="text.secondary">
                                    Nenhuma manutenção encontrada
                                </Typography>
                            </Paper>
                        )
                    ) : (
                        <TableContainer component={Paper} variant='elevation' sx={{ borderRadius: '15px' }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align='center'>Nome</TableCell>
                                        <TableCell align='center'>Descrição</TableCell>
                                        <TableCell align='center'>Datas</TableCell>
                                        <TableCell align='center'>Ação</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {values.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell align='center'>{item.nome}</TableCell>
                                            <TableCell align='center'>{item.descricao}</TableCell>
                                            <TableCell align='center'>{helpers.formatDateMaintenance(item.date)}</TableCell>
                                            <TableCell align='center'>
                                                <IconButton onClick={() => navigate(`./${item.uuid}/chat`)}><Comment /></IconButton>
                                                <IconButton onClick={() => navigate(`./${item.uuid}`)}><Search /></IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </Box>
            </Box>
        </Box>
    );
};